import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {SellableReportSelectionData} from "../../sellable/controls/sellable-report-selection-control.component";
import {EmployeeReportSelectionData} from "../../../employee/employee/controls/employee-report-selection-control.component";

export class ProductWastageReportData extends ReportData<ProductWastageReportData> {
    @collection() groupBy: string[] = ["none"];
    @collection(EmployeeReportSelectionData) employees: EmployeeReportSelectionData[];
    @field reportType: string = "SIMPLE";
    @collection(SellableReportSelectionData) sellables: SellableReportSelectionData[];
}
